module.exports = __webpack_public_path__ + "img/advisor-item-bg@3x.c4c796e1.png";